import { render } from "./CustomerSizes.vue?vue&type=template&id=4396663c&scoped=true"
import script from "./CustomerSizes.vue?vue&type=script&lang=js"
export * from "./CustomerSizes.vue?vue&type=script&lang=js"

import "./CustomerSizes.vue?vue&type=style&index=0&id=4396663c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4396663c"]])

export default __exports__